import * as types from '../constants/actionTypes';

export function changePeriod(fromDate, toDate, chasa) {
  return {  type: types.CHANGE_PERIOD, payload: { fromDate, toDate, chasa }  };
}
